export const SIGN_IN_APP = "https://app.sociilaw.com/entrar";
export const INTRO_APP = "https://app.sociilaw.com/introducao";
export const APP_TERMS = "https://app.sociilaw.com/termos-de-uso-introducao";
export const APP_PRIVACY =
  "https://app.sociilaw.com/politica-de-privacidade-introducao";

export const WHATSAPP =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20suporte%20jur%C3%ADdico%20empresarial.";
export const WHATSAPP_COMERCIAL =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20suporte%20jur%C3%ADdico%20empresarial.";

export const INSTAGRAM = "https://www.instagram.com/sociilaw/";
export const FACEBOOK = "https://www.facebook.com/sociilaw";
export const TWITTER = "https://twitter.com/sociilaw";
export const LINKEDIN = "https://www.linkedin.com/company/sociilaw/";
export const YOUTUBE =
  "https://www.youtube.com/channel/UCyyQ2uuYDN5o8IHUd8Phqew";
export const MEDIUM = "https://medium.com/@sociilaw";
export const JUSBRASIL = "https://sociilaw.jusbrasil.com.br/";

export const WHATSAPP_DREAMERS =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Dreamers%2C%20voc%C3%AA%20poderia%20me%20ajudar%3F";
export const WHATSAPP_FOUNDERS =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Founders%2C%20voc%C3%AA%20poderia%20me%20ajudar%3F";
export const WHATSAPP_INNOVATORS =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Innovators%2C%20voc%C3%AA%20poderia%20me%20ajudar%3F";

export const REGISTRY_50_OFF = "/registro50off";
export const WHATSAPP_EDGAR =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1!%20Gostaria%20de%20registrar%20minha%20marca.%20Vim%20pelo%20Edgar%20Ueda!";

export const REGISTRO_WHATSAPP_LINK_1 =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20iniciar%20uma%20an%C3%A1lise%20de%20viabilidade%20de%20marca%20gratuita.%20";
export const REGISTRO_WHATSAPP_LINK_2 =
  "https://api.whatsapp.com/send?phone=556193985580&text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20an%C3%A1lise%20de%20viabilidade%20de%20marca%20gratuita.%20";

export const CTA_HOME = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, vi a página inicial de vocês e gostaria de mais informações."
)}`;

export const CTA_SOBRE_NOS = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, vi a página 'sobre nós' de vocês e gostaria de mais informações."
)}`;

export const CTA_CLIENTES = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, vi a página 'clientes' de vocês e gostaria de mais informações."
)}`;

export const CTA_SITE = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, vi o site de vocês e gostaria de mais informações."
)}`;

export const CTA_REGISTRO_MARCA = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, gostaria de registrar minha marca! Preciso de mais informações."
)}`;

export const CTA_ANALISE = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, preciso analisar a viabilidade da minha marca! Preciso de mais informações."
)}`;

export const CTA_CONTABILIZEI = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou cliente contabilizei e gostaria de solicitar uma elaboração de contrato."
)}`;
export const CTA_CONTABILIZEI_ANALYSIS = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou cliente contabilizei e preciso de auxílio para uma análise de contrato."
)}`;

export const CTA_RM_CONTAB = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou cliente contabilizei e gostaria de registrar minha marca! Preciso de mais informações."
)}`;

export const CTA_VENTIUR = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou investido da Ventiur e gostaria de solicitar uma elaboração de contrato."
)}`;

export const CTA_RM_VENTIUR = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou investido da Ventiur e gostaria de registrar minha marca! Preciso de mais informações."
)}`;

export const CTA_MAR_CONTAB = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou cliente da Mar Contabilidade e gostaria de registrar minha marca! Preciso de mais informações."
)}`;

export const CTA_J3M_CONTAB = `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
  "Olá, sou cliente da J3M Contabilidade e gostaria de registrar minha marca! Preciso de mais informações."
)}`;

export const CTA_REFERRAL = (code) =>
  `https://api.whatsapp.com/send?phone=556193985580&text=${encodeURI(
    `Olá, fui indicado por um(a) cliente com código ${code} e gostaria de saber mais a respeito do desconto de R$ 50 da indicação.`
  )}`;
